"use strict";
var core_1 = require('@angular/core');
var button_1 = require('../../button');
var core_2 = require('@angular/core');
var PlayControls = (function () {
    function PlayControls() {
        this.playing = false;
        this.looping = false;
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], PlayControls.prototype, "playing", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], PlayControls.prototype, "looping", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], PlayControls.prototype, "play", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], PlayControls.prototype, "stop", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], PlayControls.prototype, "pause", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], PlayControls.prototype, "sequenceLength", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], PlayControls.prototype, "amplitude", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], PlayControls.prototype, "updateAmplitude", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], PlayControls.prototype, "changePosition", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], PlayControls.prototype, "currentPosition", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Function)
    ], PlayControls.prototype, "toggleLooping", void 0);
    PlayControls = __decorate([
        core_1.Component({
            selector: 'play-controls',
            template: "\n    <div class=\"flex control-bar\">\n      <rio-button (click)=\"changePosition(-sequenceLength)\">\n        <i class=\"fa fa-fast-backward\">\n        </i>\n      </rio-button>\n      <rio-button (click)=\"changePosition(-2)\">\n        <i class=\"fa fa-step-backward\">\n        </i>\n      </rio-button>\n      <rio-button (click)=\"playing ? pause() : play()\">\n        <i class=\"fa\" [ngClass]=\"{'fa-pause': playing, 'fa-play': !playing }\">\n        </i>\n      </rio-button>\n      <rio-button (click)=\"changePosition(2)\">\n        <i class=\"fa fa-step-forward\">\n        </i>\n      </rio-button>\n      <rio-button (click)=\"stop()\"\n        [disabled]=\"!playing && currentPosition === 0\">\n        <i class=\"fa fa-stop\">\n        </i>\n      </rio-button>\n      <rio-button (click)=\"toggleLooping()\">\n        <i class=\"fa fa-refresh\" [ngClass]=\"{'fa-spin': looping }\">\n        </i>\n      </rio-button>\n      <input type=\"range\" class=\"input-range\"\n        [value]=\"amplitude * 100\"\n        (input)=\"updateAmplitude($event.target.value / 100)\">\n    </div>\n  ",
            encapsulation: core_2.ViewEncapsulation.Emulated,
            styles: ["\n    .control-bar {\n      padding: .5em;\n    }\n    rio-button { margin-right: .3em; }\n  "],
            directives: [button_1.RioButton],
            changeDetection: core_2.ChangeDetectionStrategy.OnPush,
        }), 
        __metadata('design:paramtypes', [])
    ], PlayControls);
    return PlayControls;
}());
exports.PlayControls = PlayControls;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEscUJBQWlDLGVBQWUsQ0FBQyxDQUFBO0FBQ2pELHVCQUEwQixjQUFjLENBQUMsQ0FBQTtBQUN6QyxxQkFHTyxlQUFlLENBQUMsQ0FBQTtBQStDdkI7SUFhRTtRQVpTLFlBQU8sR0FBWSxLQUFLLENBQUM7UUFDekIsWUFBTyxHQUFZLEtBQUssQ0FBQztJQVlsQyxDQUFDO0lBYkQ7UUFBQyxZQUFLLEVBQUU7O2lEQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7O2lEQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7OzhDQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7OzhDQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7OytDQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7O3dEQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7O21EQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7O3lEQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7O3dEQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7O3lEQUFBO0lBQ1I7UUFBQyxZQUFLLEVBQUU7O3VEQUFBO0lBeERWO1FBQUMsZ0JBQVMsQ0FBQztZQUNULFFBQVEsRUFBRSxlQUFlO1lBQ3pCLFFBQVEsRUFBRSxtbENBK0JUO1lBQ0QsYUFBYSxFQUFFLHdCQUFpQixDQUFDLFFBQVE7WUFDekMsTUFBTSxFQUFFLENBQUMsK0ZBS1IsQ0FBQztZQUNGLFVBQVUsRUFBRSxDQUFDLGtCQUFTLENBQUM7WUFDdkIsZUFBZSxFQUFFLDhCQUF1QixDQUFDLE1BQU07U0FDaEQsQ0FBQzs7b0JBQUE7SUFpQkYsbUJBQUM7QUFBRCxDQUFDLEFBZkQsSUFlQztBQWZZLG9CQUFZLGVBZXhCLENBQUE7QUFBQSxDQUFDIn0=


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/sequencer/play-controls/index.ts
 ** module id = 962
 ** module chunks = 1
 **/